"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
const basePolicyRequest_1 = __importDefault(require("../../basePolicy/basePolicyRequest"));
const commoditiesAndProtection_1 = __importDefault(require("../mtcSteps/commoditiesAndProtection"));
const endorsements_1 = __importDefault(require("../mtcSteps/endorsements"));
const supplementalCoverages_1 = __importDefault(require("../mtcSteps/supplementalCoverages"));
class MTCRequest extends basePolicyRequest_1.default {
    constructor(basePolicyRequestData, data) {
        super(basePolicyRequestData);
        this.assured = data.assured;
        this.stepsMotorTruckCargo = data.stepsMotorTruckCargo;
        this.verifyDetails = data.verifyDetails;
        this.commoditiesAndProtection = data.commoditiesAndProtection;
        this.supplementalCoverages = data.supplementalCoverages;
        this.optionalEndorsements = data.optionalEndorsements;
        this.isRequiredAPD = data.isRequiredAPD;
    }
    static fromObj(data) {
        return new MTCRequest(data, {
            assured: data.assured,
            stepsMotorTruckCargo: data.stepsMotorTruckCargo,
            verifyDetails: __1.VerifyDetails.fromObj(data.verifyDetails),
            commoditiesAndProtection: commoditiesAndProtection_1.default.fromObj(data.commoditiesAndProtection),
            supplementalCoverages: supplementalCoverages_1.default.fromObj(data.supplementalCoverages),
            optionalEndorsements: endorsements_1.default.fromObj(data.optionalEndorsements),
            isRequiredAPD: data.isRequiredAPD || false
        });
    }
    static createRequest(type, region, partnerId, user, channel, broker, effectiveDate, callback, data) {
        const basePolicyRequest = basePolicyRequest_1.default.create({
            type,
            partnerId,
            user,
            channel,
            broker,
            callback,
            region,
            effectiveDate
        });
        return new MTCRequest(basePolicyRequest, {
            assured: data === null || data === void 0 ? void 0 : data.assured,
            stepsMotorTruckCargo: data === null || data === void 0 ? void 0 : data.stepsMotorTruckCargo,
            verifyDetails: data === null || data === void 0 ? void 0 : data.verifyDetails,
            commoditiesAndProtection: data === null || data === void 0 ? void 0 : data.commoditiesAndProtection,
            supplementalCoverages: data === null || data === void 0 ? void 0 : data.supplementalCoverages,
            optionalEndorsements: data === null || data === void 0 ? void 0 : data.optionalEndorsements,
            isRequiredAPD: data === null || data === void 0 ? void 0 : data.isRequiredAPD
        });
    }
}
exports.default = MTCRequest;
//# sourceMappingURL=mtcRequest.js.map